module.exports = __webpack_public_path__ + "static/media/abouticon3.baa7a1fc.png";